export enum InteractTypeEnum {
  Play = 'play',
  Button = 'button',
  Hand = 'hand'
}
